import React from "react";
import { ReactComponent as CloseIcon } from "Assets/Icons/Home/CloseIcon.svg";
import { ReactComponent as CalendarIcon } from "Assets/Icons/Home/CalendarIcon.svg";
import { ReactComponent as ClockIcon } from "Assets/Icons/Home/ClockIcon.svg";
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormLabel,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import { TimelineDot } from "@mui/lab";
import {
  DatePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";

const GetVideoHelp = ({ open, setOpen }) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog fullWidth maxWidth={"sm"} open={open} onClose={handleClose}>
      <DialogTitle>
        Get 1-1 help from TA and clear your doubts on a video call TAs are
        online
        <IconButton onClick={() => handleClose()}>
          {" "}
          <PrimaryIcon
            icon={CloseIcon}
            color="white"
            height="14px"
            width="14px"
          />{" "}
        </IconButton>{" "}
      </DialogTitle>
      <DialogContent>
        <Box display={"flex"} justifyContent={"end"}>
          <Chip
            variant="outlined"
            color="success"
            outlined
            label={
              <Box display={"flex"} alignItems={"center"} gap="6px">
                {" "}
                <TimelineDot
                  sx={{
                    margin: "0px",
                    alignSelf: "center",
                    padding: "1px !important",
                  }}
                  color="success"
                />{" "}
                TAs are online{" "}
              </Box>
            }
          />
        </Box>
        <FormControl fullWidth>
          <FormLabel color="secondary" required label>
            Topics
          </FormLabel>
          <Select value={"1"} fullWidth size="small">
            <MenuItem disabled value="">
              <em>Select your issue</em>
            </MenuItem>
            <MenuItem value="1">
              {" "}
              Facing Time Limit Exceeded (TLE) Error
            </MenuItem>
            <MenuItem value="2">Help clarify the problem statement</MenuItem>
            <MenuItem value="2">
              Help figure out solution approach to the problem
            </MenuItem>
            <MenuItem value="2">Facing Compilation Error</MenuItem>
            <MenuItem value="2">
              Facing Memory Limit Exceeded (MLE) Error
            </MenuItem>
            <MenuItem value="2">Facing Runtime Error</MenuItem>
            <MenuItem value="2">Help me Rectify the Syntax</MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <Box
            mt="10px"
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <FormLabel color="secondary" required label>
              Explain the problem you are facing
            </FormLabel>
            <Typography variant="body2" color="secondary.light">
              minimum 60 words
            </Typography>
          </Box>
          <TextField
            size="small"
            placeholder="Please Provide a detailed explanation of your issue in a minimum of 50 words in here"
            multiline
            rows={3}
          />
        </FormControl>
        <Box mt="10px">
          <FormLabel color="secondary" required label>
            Select your availability for the 1:1 with TA
          </FormLabel>
          <Typography color="secondary.light" variant="body2">
            We will find the best-matched TA as soon as you submit this request.
            If no TA is available immediately, we will schedule it based on your
            slots below.
          </Typography>
          <Box mt="10px" display={"flex"} flexDirection={"column"} gap="10px">
            {["#FEE0CC", "#D4F7ED"]?.map((item, i) => {
              return (
                <Box
                  key={i}
                  sx={(theme) => ({
                    borderRadius: "8px",
                    background: item,
                    padding: "8px",
                  })}
                >
                  <Typography>Slot-01</Typography>
                  <Box display={"flex"} gap="20px">
                    <FormControl
                      color="secondary"
                      fullWidth
                      size="small"
                      variant="outlined"
                    >
                      <FormLabel label>Select your day</FormLabel>
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                          defaultValue={moment()}
                          format="DD-MM-YYYY"
                          sx={(theme) => ({
                            "& fieldset": {
                              borderColor: `${theme.palette.secondary.main} !important`,
                            },
                          })}
                          slotProps={{
                            textField: {
                              size: "small",
                            },
                          }}
                          slots={{
                            openPickerIcon: () => (
                              <PrimaryIcon
                                width="18px"
                                height="18px"
                                icon={CalendarIcon}
                              />
                            ),
                          }}
                        />
                      </LocalizationProvider>
                    </FormControl>
                    <FormControl fullWidth>
                      <FormLabel label>Select your time</FormLabel>
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <TimePicker
                          defaultValue={moment()}
                          sx={(theme) => ({
                            "& fieldset": {
                              borderColor: `${theme.palette.secondary.main} !important`,
                            },
                          })}
                          slotProps={{
                            textField: {
                              size: "small",
                            },
                          }}
                          slots={{
                            openPickerIcon: () => (
                              <PrimaryIcon
                                width="18px"
                                height="18px"
                                icon={ClockIcon}
                              />
                            ),
                          }}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions align="end">
        <Button type="submit" variant="contained">
          Confirm and Raise Request
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GetVideoHelp;
